// import Avatar from 'boring-avatars'
import dayjs from 'dayjs'
import { Link } from 'react-router-dom'

import ExitIcon from '@/assets/icons/exit.svg?react'
import PersonIcon from '@/assets/icons/person.svg?react'
import { Trans } from '@/components'
// import { useAccount } from '@/hooks/use-account'
import { EduVerify, EduVerifyStatus } from '@/models/profile.ts'
import { useUserStore } from '@/stores/user'
import { emitter } from '@/utils/eventBus'
import { formatUserName } from '@/utils/formatter'

import { Divider } from './base/Divider'
import { UserAvatar } from './UserAvatar'

interface UserDropdownProps {
  eduVerify?: EduVerify
}

export function UserDropdown({ eduVerify }: UserDropdownProps) {
  const userStore = useUserStore()

  return (
    <div className="relative">
      <div className="absolute top-full right-0 mt-2 w-[280px] bg-white rounded-2xl shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
        <div className="p-4">
          <div className="flex flex-col justify-center space-y-4">
            <div className="flex items-center space-x-2">
              {/* <Avatar size={40} name={userStore.name} variant="beam" colors={['#525866']} /> */}
              <UserAvatar size={40} />
              <div>
                <div className="t-sb">{formatUserName(userStore.name)}</div>
                {/* <div className="t-xs text-secondary">{userStore.name}</div> */}
              </div>
            </div>

            {eduVerify?.status === EduVerifyStatus.Verified && (
              <div className="flex gap-x-4">
                <div className="flex p-2 bg-neutral-100 rounded-lg gap-x-2 t-x-sb text-primary">
                  Education
                </div>
                <div className="flex p-2 bg-neutral-100 rounded-lg gap-x-2 t-x-sb text-primary">
                  {dayjs(eduVerify?.graduationTime.seconds).format('YYYY-MM-DD')}
                </div>
              </div>
            )}
          </div>

          <Divider className="my-2" />

          <div className="space-y-1">
            <Link
              className="flex items-center space-x-2 p-2 w-full hover:bg-neutral-50 rounded-lg cursor-pointer"
              to="/profile"
            >
              <PersonIcon className="w-4 h-4 text-tertiary" />
              <span className="t-sm">
                <Trans i18nKey="header.userDropdown.profile">My Account</Trans>
              </span>
            </Link>

            <Divider className="my-2" />
            <button
              className="flex items-center space-x-2 p-2 w-full hover:bg-neutral-50 rounded-lg cursor-pointer"
              onClick={() => {
                emitter.emit('LOGOUT', { reason: 'Manual' })
              }}
            >
              <ExitIcon className="w-4 h-4 text-tertiary" />
              <span className="t-sm">
                <Trans i18nKey="header.userDropdown.logout">Log out</Trans>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
